import * as React from 'react';

export const SelectFeedType = React.lazy(() => import('./SelectFeedType'));
